// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__sticknet___VF15i {
    font-family: 'Sirin Stencil', sans-serif;
    font-size: 32px;
}

.style__premium___KhIHV {
    font-weight: bold;
}

.style__shieldText___D_4R2 {
    font-size: 15px;
    display: flex;
    align-items: center;
    align-self: flex-start;
    margin-left: 16px;
    margin-top: 8px;

}

.style__itemContainer___MiNpb {
    padding: 8px;
    border-radius: 10px;
    width: 100%;
    justify-content: center;
    background-color: #ffffff;
    margin-left: 8px;
    margin-right: 8px;
    margin-bottom: 40px;
    box-shadow: 1px 3px 10px 2px rgba(96, 96, 255, 0.25);
}

.style__titleContainer___fHicw {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 8px;
}

.style__basicText___WYbww {
    color: grey;
}

.style__upgradeButton___dADcs {
    /*padding: 8px 100px;*/
    margin-bottom: 28px;
}

.style__cancel___ZmUIK {
    color: grey;
    text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/client/PremiumScreen/style.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;IACxC,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;;AAEnB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B","sourcesContent":[".sticknet {\n    font-family: 'Sirin Stencil', sans-serif;\n    font-size: 32px;\n}\n\n.premium {\n    font-weight: bold;\n}\n\n.shieldText {\n    font-size: 15px;\n    display: flex;\n    align-items: center;\n    align-self: flex-start;\n    margin-left: 16px;\n    margin-top: 8px;\n\n}\n\n.itemContainer {\n    padding: 8px;\n    border-radius: 10px;\n    width: 100%;\n    justify-content: center;\n    background-color: #ffffff;\n    margin-left: 8px;\n    margin-right: 8px;\n    margin-bottom: 40px;\n    box-shadow: 1px 3px 10px 2px rgba(96, 96, 255, 0.25);\n}\n\n.titleContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.basicText {\n    color: grey;\n}\n\n.upgradeButton {\n    /*padding: 8px 100px;*/\n    margin-bottom: 28px;\n}\n\n.cancel {\n    color: grey;\n    text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sticknet": `style__sticknet___VF15i`,
	"premium": `style__premium___KhIHV`,
	"shieldText": `style__shieldText___D_4R2`,
	"itemContainer": `style__itemContainer___MiNpb`,
	"titleContainer": `style__titleContainer___fHicw`,
	"basicText": `style__basicText___WYbww`,
	"upgradeButton": `style__upgradeButton___dADcs`,
	"cancel": `style__cancel___ZmUIK`
};
export default ___CSS_LOADER_EXPORT___;
